import React from 'react';
import './Loading.css';

function Loading() {
  return (
    <div className="loading-container">
      <div className="loading-content">
        <div className="loading-logo-wrapper">
          <img 
            src="/images/503547065_18084417088686417_5527300001175770798_n.jpg" 
            alt="Kinesis Fit Center Logo" 
            className="loading-logo"
            onError={(e) => {
              console.error('Errore nel caricamento del logo:', e);
              e.target.style.display = 'none';
            }}
          />
        </div>
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <p className="loading-text">Caricamento...</p>
      </div>
    </div>
  );
}

export default Loading;

